import PropTypes from 'prop-types'
import {
  CircularProgress,
  TextField,
  Autocomplete as MuiAutocomplete,
  InputAdornment,
} from '@mui/material'

import { ReactComponent as SearchIcon } from '../../../assets/icons/magnifying-glass.svg'

// TODO: refactor input props
const Autocomplete = ({
  options,
  isLoading,
  inputProps,
  InputLabelProps,
  noClearButton,
  disableClearable = false,
  noSearchIcon,
  ...props
}) => (
  <MuiAutocomplete
    options={options}
    disableClearable={disableClearable || !noSearchIcon}
    renderInput={params => (
      <TextField
        {...{ ...params, ...inputProps }}
        inputProps={{
          ...params.inputProps,
          autoComplete: 'off',
        }}
        InputLabelProps={InputLabelProps}
        InputProps={{
          ...params.InputProps,

          endAdornment: (
            <>
              {!noSearchIcon && !isLoading ? (
                <InputAdornment position="start">
                  {<SearchIcon style={{ padding: 5, marginRight: 5 }} />}
                </InputAdornment>
              ) : null}
              {isLoading ? <CircularProgress size={20} /> : null}
              {!noClearButton && params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
    {...props}
  />
)

// TODO: check this out
Autocomplete.propTypes = {
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  noClearButton: PropTypes.bool,
  disableClearable: PropTypes.bool,
  inputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  noSearchIcon: PropTypes.bool,
}

export default Autocomplete
